<template>
    <div>
        <field-name :recipientInfo="recipientInfo"></field-name>
        <field-iban :recipientInfo="recipientInfo"></field-iban>
        <field-bic :recipientInfo="recipientInfo"></field-bic>
    </div>
</template>

<script>

    import fieldName from './match-confirmed-reveal-field-name';
    import fieldIban from './match-confirmed-reveal-field-iban';
    import fieldBic from './match-confirmed-reveal-field-bic';

    export default {
        name: "match-confirmed-reveal-sepa",
        props: {
            recipientInfo: Object
        },
        components: {
           fieldName,
           fieldIban,
           fieldBic,
        },
    };
</script>
